import * as React from 'react';
import { Head } from '..';
import { useDayPicker } from "../../contexts";
import { getWeeks } from "./utils/getWeeks";
/**
 * Render the table with the calendar.
 */

export function Table(props) {
  var _a = useDayPicker(),
      locale = _a.locale,
      classNames = _a.classNames,
      styles = _a.styles,
      hideHead = _a.hideHead,
      fixedWeeks = _a.fixedWeeks,
      _b = _a.components,
      Row = _b.Row,
      Footer = _b.Footer;

  var weeks = getWeeks(props.displayMonth, {
    locale: locale,
    fixedWeeks: fixedWeeks
  });
  return /*#__PURE__*/React.createElement("table", {
    className: classNames.table,
    style: styles.table
  }, !hideHead && /*#__PURE__*/React.createElement(Head, null), /*#__PURE__*/React.createElement("tbody", {
    className: classNames.tbody,
    style: styles.tbody
  }, Object.keys(weeks).map(function (weekNumber) {
    return /*#__PURE__*/React.createElement(Row, {
      displayMonth: props.displayMonth,
      key: weekNumber,
      dates: weeks[weekNumber],
      weekNumber: Number(weekNumber)
    });
  })), /*#__PURE__*/React.createElement(Footer, null));
}